import { Link } from 'react-router-dom';
import { categories, movies } from '@/mocks/movies';

export default function CategorySection() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-12 md:py-16">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            <a href="#categories" id="categories">电影分类</a>
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型浏览您喜欢的电影</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => {
            const count = movies.filter((m) => m.category === cat.slug).length;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group relative rounded-lg overflow-hidden bg-background-50 border border-background-200/70 p-5 md:p-6 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                  <i className={`${cat.icon} text-xl md:text-2xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                </div>
                <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-1 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500">{count} 部电影</p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}